define('shoptheme/components/blocks/fce/elements/hero-slider',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"json!shoptheme/etc/breakpoints.json",
	"enquire"
], function(
	$,
	Component,
	BEM,
	BreakPoints,
	enquire
) {
	return Component.create({

		blocks: null,

		$init: function() {



			this.blocks = BEM.block('hero-slider');
			this.blocks.each(function() {

				var block = BEM.block(this);
				var headlines = block.getElements('headline');
				var sublines = block.getElements('subline');

				var maxSublineHeight = Math.max.apply(Math,sublines.map(function(){
					return $(this).height();
				}).get());

				var maxHeight = Math.max.apply(Math,headlines.map(function(){
					return $(this).height();
				}).get());

				enquire.register('(min-width: ' + (BreakPoints.sm + 1) + 'px)', {
					match: function() {
						headlines.css('height', maxHeight + 'px');
						sublines.css('height', maxSublineHeight + 'px');
					},
					unmatch: function() {
						headlines.css('height', 'auto');
						sublines.css('height', 'auto');

					}
				}, true);

				//headlines.css('height', maxHeight + 'px')

			});

		}

	});
});
